import { Component } from '@angular/core';
import {PlayerActivity} from "../../entities/players/PlayerActivity";
import {APIService} from "../../services/APIService";
import {PlayerBoothActivity} from "../../entities/players/PlayerBoothActivity";

@Component({
  selector: 'app-staff-activity',
  templateUrl: './staff-activity.component.html',
  styleUrls: ['./staff-activity.component.css']
})
export class StaffActivityComponent {
  datasource: PlayerActivity[] = [];
  boothDatasource: PlayerBoothActivity[] = [];

  columns: string[] = ['player', 'rank', 'onlinetime', 'afktime', 'lastseen']
  boothColumns: string[] = ['player', 'rank', 'lastseen', 'onlinetime', 'teleported', 'approved', 'denied']

  constructor(private apiService: APIService) {
    this.apiService.getActivity().then((a) => this.datasource = this.filterStaff(a));
    this.apiService.getBoothActivity().then((a) => this.boothDatasource = this.filterStaff(a));
  }

  private filterStaff<T extends { rank: { priority: number } }>(list: T[]): T[] {
    // Keep only users with a non-default rank (priority > 0)
    return (list || []).filter(p => p.rank && typeof p.rank.priority === 'number' && p.rank.priority > 100);
  }

  formatDuration(msText: string | number | null | undefined): string {
    if (msText === null || msText === undefined) return '—';
    const ms = typeof msText === 'string' ? parseInt(msText) : Number(msText);
    if (!isFinite(ms) || isNaN(ms)) return '—';
    let totalSeconds = Math.floor(ms / 1000);
    const days = Math.floor(totalSeconds / 86400); totalSeconds -= days * 86400;
    const hours = Math.floor(totalSeconds / 3600); totalSeconds -= hours * 3600;
    const minutes = Math.floor(totalSeconds / 60); totalSeconds -= minutes * 60;
    const seconds = totalSeconds;

    const parts: string[] = [];
    if (days) parts.push(days + 'd');
    if (hours) parts.push(hours + 'h');
    if (minutes) parts.push(minutes + 'm');
    if (seconds || parts.length === 0) parts.push(seconds + 's');
    return parts.join(' ');
  }

  formatLastSeen(tsText: string | number | Date | null | undefined): string {
    if (tsText === null || tsText === undefined) return '—';
    let ms: number;
    if (tsText instanceof Date) ms = tsText.getTime();
    else if (typeof tsText === 'string') {
      const n = parseInt(tsText);
      if (!isFinite(n) || isNaN(n)) return '—';
      // Heuristic: if value looks like seconds, scale to ms
      ms = n < 10_000_000_000 ? n * 1000 : n;
    } else {
      const n = Number(tsText);
      if (!isFinite(n) || isNaN(n)) return '—';
      ms = n < 10_000_000_000 ? n * 1000 : n;
    }
    const d = new Date(ms);
    return d.toLocaleString();
  }
}
